// 语音视频聊天——主流程
const MainRoutes = Array.from({ length: 11 }, (_, i) => ({
  path: `chat/index${i + 1}`,
  name: `chatIndex${i + 1}`,
  component: () => import(`@/views/wxSettings/chat/index${i + 1}.vue`)
}))
const BranchRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `chat/branch/index${i + 1}`,
  name: `chatBranchIndex${i + 1}`,
  component: () => import(`@/views/wxSettings/chat/branch/index${i + 1}.vue`)
}))



export default {
  path: '/wxSettings',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 语音视频聊天——主流程，开始
    ...MainRoutes,
    // 语音视频聊天——分支流程，开始
    ...BranchRoutes,


  ],
};
